import {Component} from '@angular/core';
import {ActivatedRouteSnapshot, ActivationEnd, Event, NavigationEnd, Router} from '@angular/router';
import {bufferWhen, filter, map} from 'rxjs/operators';

interface TabItem {
  path: string;
  label: string;
  disabled?: boolean;
  icon?: string;
}

@Component({
  selector: 'gt-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.scss']
})
export class TabMenuComponent {
  tabItems$ = this.router.events.pipe(
    // buffer router events until NavigationEnd arrives on the event stream
    bufferWhen(() => this.router.events.pipe(filter(e => e instanceof NavigationEnd))),
    // get ActivationEnd events, check if it is a tabMenu route, in that case, grab menu information from its children
    map(events => this.mapEventsToTabItems(events))
  );

  constructor(private router: Router) {}

  private mapEventsToTabItems(events: Event[]): TabItem[] {
    return events
      .filter(e => e instanceof ActivationEnd && e.snapshot.routeConfig.data?.tabMenu)
      .map((e: ActivationEnd) => {
        return e.snapshot.routeConfig.children
          .filter(r => r.path && r.data)
          .map(
            r =>
              ({
                path: `${this.getUrl(e.snapshot)}/${r.path}`,
                label: r.data.label,
                icon: r.data.icon
              } as TabItem)
          );
      })
      .reduce((acc, tabItems) => acc.concat(tabItems), [] as TabItem[]);
  }

  private getUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map(snapshot => snapshot.url.map(u => u.path))
      .filter(p => p?.length > 0)
      .join('/');
  }
}
